module.exports = __webpack_public_path__ + "images/258fe0717f6d80c555b5af9e9feb546b.svg";